export default __webpack_public_path__ + "legacy/static/media/AppleInstructions.ced12666.png";